(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);
  function initCheckoutConsent() {
    const checkbox = document.getElementById('checkout-consent');
    const checkoutButton = document.getElementById('checkout');
    const dynamicWrapper = document.getElementById('dynamic-checkout-wrapper');

    if (!checkbox || !checkoutButton) return;

    function updateState() {
      const enabled = checkbox.checked;

      checkoutButton.disabled = !enabled;

      if (dynamicWrapper) {
        dynamicWrapper.setAttribute(
          'data-disabled',
          enabled ? 'false' : 'true'
        );
      }
    }

    // Estado inicial
    updateState();

    checkbox.addEventListener('change', updateState);
  }

  document.addEventListener('DOMContentLoaded', initCheckoutConsent);
  document.addEventListener('shopify:section:load', initCheckoutConsent);

  } catch(e) { console.error(e); }
})();
})();
